"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;
var gql = String.raw;
var create_entity_1 = require("../../utils/create-entity");
var use_open_graph_query_1 = require("../../hooks/use-open-graph-query");
var lodash_1 = require("lodash");
var immer_1 = __importDefault(require("immer"));
var validator_1 = __importDefault(require("validator"));
var video_card_1 = require("../../components/entities/video-card");
var video_details_layout_1 = require("../../components/entities/video-details-layout");
var graphql_1 = require("../../utils/graphql");
var components_1 = require("../../components");
var replace = function (draft, key, fieldState, value, valueKey, force) {
  if (valueKey === void 0) {
    valueKey = 'value';
  }
  if (force === void 0) {
    force = false;
  }
  draft[key] = draft[key] || {};
  if (value && (force || !(0, lodash_1.get)(fieldState, "".concat(key, ".").concat(valueKey)))) {
    draft[key][valueKey] = value;
    draft[key].loadingMessage = '';
    draft[key].disabled = false;
  }
};
var restoreFieldState = function (_a) {
  var fieldState = _a.fieldState,
    onChange = _a.onChange;
  var newState = (0, immer_1.default)(fieldState, function (draft) {
    (0, lodash_1.each)(['name', 'thumbnail', 'description'], function (key) {
      draft[key] = draft[key] || {};
      draft[key].loadingMessage = '';
      draft[key].disabled = false;
    });
  });
  onChange(newState);
};
var handleUrlBlur = function (_a) {
  return __awaiter(void 0, [_a], void 0, function (_b) {
    var _c, image, loadingFieldState, data, openGraph_1, force_1, newFieldState, err_1;
    var name = _b.name,
      value = _b.value,
      fieldState = _b.fieldState,
      onChange = _b.onChange,
      client = _b.client;
    return __generator(this, function (_d) {
      switch (_d.label) {
        case 0:
          _c = fieldState.image, image = _c === void 0 ? {
            value: ''
          } : _c;
          if (!(!image.value && validator_1.default.isURL(value))) return [3 /*break*/, 4];
          if (!value.match(/youtube\.com/)) return [3 /*break*/, 4];
          loadingFieldState = (0, immer_1.default)(fieldState, function (draft) {
            (0, lodash_1.each)(['name', 'thumbnail', 'description'], function (key) {
              draft[key] = draft[key] || {};
              draft[key].loadingMessage = 'Fetching';
              draft[key].disabled = true;
            });
          });
          onChange(loadingFieldState);
          _d.label = 1;
        case 1:
          _d.trys.push([1, 3,, 4]);
          return [4 /*yield*/, client.query({
            query: use_open_graph_query_1.OPEN_GRAPH_QUERY,
            variables: {
              url: value
            }
          })];
        case 2:
          data = _d.sent().data;
          openGraph_1 = data.openGraph;
          force_1 = false;
          if (openGraph_1) {
            newFieldState = (0, immer_1.default)(fieldState, function (draft) {
              replace(draft, 'name', fieldState, openGraph_1.title, 'value', force_1);
              replace(draft, 'description', fieldState, openGraph_1.description, 'value', force_1);
              replace(draft, 'thumbnail', fieldState, openGraph_1.image, 'value', force_1);
            });
            onChange(newFieldState);
          } else {
            restoreFieldState({
              fieldState: fieldState,
              onChange: onChange
            });
          }
          return [3 /*break*/, 4];
        case 3:
          err_1 = _d.sent();
          restoreFieldState({
            fieldState: fieldState,
            onChange: onChange
          });
          return [3 /*break*/, 4];
        case 4:
          return [2 /*return*/];
      }
    });
  });
};
exports.Video = {
  name: 'Video',
  useDuplicateCheck: true,
  canCreateInConversation: true,
  useConnections: true,
  useSlices: true,
  useSites: true,
  includeInSearch: true,
  includeInMetrics: true,
  groupName: 'Library',
  canEmbed: true,
  table: {
    fieldNames: ["name", "url", "thumbnail"]
  },
  components: {
    card: video_card_1.VideoCard,
    details: video_details_layout_1.VideoDetailsLayout,
    image: components_1.VideoImage
  },
  banner: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ...EntityValueFields\n    "], ["\n      ...EntityValueFields\n    "])))
  },
  export: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      name\n      url\n      description { text }\n      people { name }\n      ...TaxonomyExportFields\n      sites { name }\n    "], ["\n      name\n      url\n      description { text }\n      people { name }\n      ...TaxonomyExportFields\n      sites { name }\n    "])))
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      url\n      description { ...ContentNodeFields }\n      people { ...EntityValueFields path }\n      ...TaxonomyFields\n    "], ["\n      url\n      description { ...ContentNodeFields }\n      people { ...EntityValueFields path }\n      ...TaxonomyFields\n    "])))
  },
  filters: {
    fields: {
      challenges: {
        entityTypeName: 'Challenge'
      },
      people: {
        entityTypeName: 'Person'
      },
      keyIssues: {
        entityTypeName: 'KeyIssue'
      },
      trends: {
        entityTypeName: 'Trend'
      },
      topics: {
        entityTypeName: 'Topic'
      },
      subTopics: {
        entityTypeName: 'SubTopic'
      },
      sdgs: {
        entityTypeName: 'SubTopic'
      }
    }
  },
  list: {
    queryFields: (0, graphql_1.graphql)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      url\n      ...TaxonomyFields\n      description { id text plain plainTruncated: plain(truncate: { words: 25 }) }\n    "], ["\n      url\n      ...TaxonomyFields\n      description { id text plain plainTruncated: plain(truncate: { words: 25 }) }\n    "])))
  },
  form: {
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'taxonomies',
      label: process.env.TAXONOMIES_LABEL || 'Challenges & Goals'
    }, {
      name: 'community'
    }],
    fields: {
      url: {
        type: 'url',
        focus: true,
        onBlur: handleUrlBlur
      },
      id: create_entity_1.entityStandardFormFields.id,
      name: __assign(__assign({}, create_entity_1.entityStandardFormFields.name), {
        focus: false
      }),
      authors: {
        type: 'linkedMultiple',
        label: 'Authors',
        entityTypeName: 'Person',
        fieldSet: 'overview'
      },
      published: {
        type: 'date',
        description: 'When was this article published?'
      },
      description: {
        type: 'description'
      },
      thumbnail: {
        type: 'image'
      },
      challenges: {
        type: 'linkedMultiple',
        entityTypeName: 'Challenge',
        fieldSet: 'taxonomies'
      },
      keyIssues: {
        type: 'linkedMultiple',
        entityTypeName: 'KeyIssue',
        fieldSet: 'taxonomies'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'taxonomies'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'taxonomies'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'taxonomies'
      },
      sdgs: {
        type: 'linkedMultiple',
        entityTypeName: 'Sdg',
        fieldSet: 'taxonomies'
      },
      people: {
        type: 'linkedMultiple',
        entityTypeName: 'Person',
        fieldSet: 'community'
      }
    }
  },
  select: {
    maxWidth: '400px'
  },
  autoRoutes: ['create', 'update', 'list', 'details']
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;